<template>
  <section class="is--promo">
    <div class="container">
      <div class="container-inner">
        <div class="row">
          <div class="col-xs-12 col-lg-6">
            <div class="promo-content">
              <h2>
                Zaun24 ist Testsieger!
              </h2>
              <p>Zaun24 wurde in 2026 erneut von euch zum Besten Onlineshop in der Kategorie Gartenzäune gewählt. Wir sind sehr stolz, dass wir uns mit Service und Qualität wieder einmal gegen unsere Wettbewerber durchsetzen konnten.</p>
              <p><strong>ZAUN24: Kompetenz und Qualität seit 2008</strong></p>
            </div>
            <div class="promo-content-image">
              <img
                class="badge"
                v-lazy="'/assets/logo/beste-haendler-2026.svg'"
                alt="Zaun24 Beste Haendler 2026"
                width="100%"
                height="auto"
              >
              <img
                class="badge hidden-lg hidden-xl"
                v-lazy="'/assets/logo/siegel.svg'"
                alt="Zaun24 Beste Händler 2026"
                width="240px"
                height="auto"
                style="z-index:6;"
              >
            </div>
          </div>

          <div class="col-xs-12 col-lg-6 promo-image-container hidden-xs hidden-sm hidden-md">
            <div class="promo-image">
              <img
                class="badge"
                v-lazy="'/assets/logo/siegel.svg'"
                alt="Zaun24 Beste Händler 2026"
                width="240"
                height="240"
              >
              <img
                class="badge"
                v-lazy="'/assets/logo/siegel-25.svg'"
                alt="Zaun24 Beste Händler 2025"
                width="185"
                height="185"
              >
              <img
                class="badge"
                v-lazy="'/assets/logo/siegel-24.svg'"
                alt="Zaun24 Beste Händler 2024"
                width="175"
                height="175"
              >
              <img
                class="badge"
                v-lazy="'/assets/logo/siegel-23.svg'"
                alt="Zaun24 Beste Händler 2023"
                width="165"
                height="165"
              >
              <img
                class="badge"
                v-lazy="'/assets/logo/siegel-22.svg'"
                alt="Zaun24 Beste Händler 2022"
                width="155"
                height="155"
              >
              <img
                class="badge"
                v-lazy="'/assets/logo/siegel-21.svg'"
                alt="Zaun24 Beste Händler 2021"
                width="145"
                height="145"
              >
              <img
                class="badge"
                v-lazy="'/assets/logo/siegel-20.svg'"
                alt="Zaun24 Beste Händler 2020"
                width="135"
                height="135"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PromoZaun24'
}
</script>
